window.onload = function () {
  scroll_effect();

  $(window).scroll(function () {
    scroll_effect();
  });

  function scroll_effect() {
    $('.aw-headline').each(function () {
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height() - 250;
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-headline-scroll');
      }
    });
    $('.fade-in').each(function () {
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height() - 150;
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('active');
      }
    });
  }
};